import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function TransformationSection() {
  const benefits = ['baja el pánico', 'baja el “me voy a arruinar mañana”', 'tu cuerpo deja de pelear', 'tu mente deja de correr tanto'];
  return <section className="py-24 px-4" data-id="element-176">
      <div className="max-w-3xl mx-auto text-center" data-id="element-177">
        <SectionWrapper data-id="element-178">
          <h2 className="text-3xl md:text-5xl text-[var(--text-primary)] mb-12" data-id="element-179">
            Lo que pasa cuando por fin tienes un plan
          </h2>

          <div className="mb-12 space-y-4" data-id="element-180">
            <p className="text-xl text-[var(--text-secondary)]" data-id="element-181">
              Cuando te despiertas a las 3AM y sabes qué hacer:
            </p>
          </div>
        </SectionWrapper>

        <div className="mb-12" data-id="element-182">
          <ul className="inline-block text-left space-y-3" data-id="element-183">
            {benefits.map((benefit, i) => <SectionWrapper key={i} delay={0.1 + i * 0.1} data-id="element-184">
                <li className="text-lg md:text-xl text-[var(--text-primary)] flex items-center" data-id="element-185">
                  <span className="w-2 h-2 rounded-full bg-[var(--accent-teal)] mr-4" data-id="element-186"></span>
                  {benefit}
                </li>
              </SectionWrapper>)}
          </ul>
        </div>

        <SectionWrapper delay={0.5} data-id="element-187">
          <div className="py-8 border-y border-[var(--bg-card-hover)]" data-id="element-188">
            <p className="text-xl text-[var(--text-secondary)] mb-4" data-id="element-189">
              Y aunque no sea perfecto la primera noche… <br data-id="element-190" />
              por primera vez sientes algo que no sentías hace tiempo:
            </p>
            <p className="text-5xl md:text-7xl font-serif text-[var(--accent-amber)] italic tracking-wide" data-id="element-191">
              control.
            </p>
          </div>
        </SectionWrapper>
      </div>
    </section>;
}